













import { Component, Prop, Vue } from "vue-property-decorator";
import {
  ProductInstanceResult,
  INSTANCE_STATION
} from "@futuri/cloudsso-client/src/client/types/productInstances";
import InstanceCard, { OnSelect } from "./InstanceCard.vue";
import { countKeysBy } from "@futuri/cloudsso-client/src/util";
import { Getter } from "vuex-class";
import { matchInstancesByPrefix } from "@futuri/cloudsso-client/src/instanceUtils";

@Component({
  components: { InstanceCard }
})
export default class InstanceCards extends Vue {
  @Prop() instances!: ProductInstanceResult[];
  @Prop() select?: OnSelect;
  @Prop() filterQuery?: string;
  @Prop() selectedCluster?: string;

  // @Getter("currentProduct", { namespace: "session" })
  // currentProduct?: ProductType

  @Getter("searchPrefix", { namespace: "session" })
  currentSearchPrefix?: string;

  // async triggerInstance(instance: ProductInstanceResult): Promise<void> {
  //   const email = this.$store.getters.email
  //   const { name: station, redirectUrl } = instance
  //   if (!redirectUrl) { return }

  //   const creds = await requestPostLoginCredential(station)
  //   const finalRedirectUrl = creds.redirectUrl
  //   console.log('Redirecting to: ', finalRedirectUrl)
  //   window.open(finalRedirectUrl)
  // }

  async selectInstance(
    instance: ProductInstanceResult,
    event?: MouseEvent
  ): Promise<void> {
    console.log(instance);
    if (this.select) {
      await this.select(instance, event);
    }
  }

  public submitSearch(search: string) {
    this.filterQuery = search;

    const instances = this.filteredInstances ?? [];
    if (instances.length === 1) {
      // this.triggerInstance(instances[0])
      this.selectInstance(instances[0]);
    }
  }

  get filteredInstances() {
    // const search = this.filterQuery

    // const productType = this.productType
    // const selectedCluster = this.selectedCluster
    const instances = this.instances ?? [];
    // const currentProduct = this.currentProduct

    // const productInstances = instances.filter(inst => inst.product === currentProduct)
    const stationInstances = instances.filter(
      inst => inst.instanceType === INSTANCE_STATION
    );

    // const res = stationInstances.filter(({ name, product, company }) => (
    //   (!productType || productType === 'all' || product === productType) &&
    //   (!selectedCluster || selectedCluster === 'all' || company === selectedCluster)
    //   // (!search || searchable(name).match(new RegExp(`^${search}`)))
    // )).filter(v => !!v)

    const searchPrefix = this.currentSearchPrefix ?? "";
    const res = matchInstancesByPrefix(stationInstances, searchPrefix);

    console.log(res.map(k => k.instanceId));
    const counts = countKeysBy(res, i => i.instanceId);
    console.log(counts);
    console.log(Array.from(counts.entries()).filter(e => e[1] > 1));

    return res;
  }
}

// declare module 'vue/types/vue' {
//   interface Vue {
//     private productType?: ProductType
//     searchQuery?: string
//   }
// }
